import { usePuestos, type Puesto } from "./GestionPuestos";
import { useDisclosureData } from "@/hooks/useModal";
import { ModalPuesto } from "./components/ModalPuesto";
import { TypedTable } from "@/components/ui/table/TypedTable";
import { createColumnHelper, tableFeatures } from "@tanstack/react-table";
import { useMemo } from "react";
import { CommonFeatures } from "@/hooks/useTanstackTable";

export function TablaPuestos() {
	const { data, error, isPending } = usePuestos();
	const disclosePuesto = useDisclosureData("");

	const { columns, features } = useMemo(() => Columns(disclosePuesto.open), [disclosePuesto.open]);

	return (
		<>
			<TypedTable
				className="dataTable display"
				columns={columns}
				features={features}
				data={data ?? []}

				noResultsMessage="No se encontraron pedidos"
				errorMessage="Error al cargar los puestos"
				isLoading={isPending}
				isError={error != null}
			/>

			<ModalPuesto
				show={disclosePuesto.isOpen}
				close={disclosePuesto.close}
				idPuesto={disclosePuesto.data}
			/>
		</>
	);
}




function Columns(openPuesto: (idPuesto: string) => void) {
	const columnHelper = createColumnHelper<typeof features, Puesto>();
	const features = tableFeatures(CommonFeatures);

	const accionesPuesto = (puesto: Puesto) => {
		return (
			<button className="main-color btnIcon" onClick={() => { openPuesto(puesto.idMaquina); }} type="button">
				<i className="fa fa-circle-plus" style={{ fontSize: 25, margin: "0 10px" }} />
			</button>
		);
	};

	const spanOperarios = (operarios: string) => {
		// eslint-disable-next-line react/no-danger -- Viene asi de php y no voy a cambiarlo ahora
		return <span dangerouslySetInnerHTML={{ __html: operarios }} />;
	};

	const columns = columnHelper.columns([
		columnHelper.accessor("idMaquina", { header: "ID", meta: { className: "dt-center" } }),
		columnHelper.accessor("nombreMaquina", { header: "Puesto", meta: { className: "dt-center" } }),
		columnHelper.accessor("operarios", { header: "Operarios", cell: info => spanOperarios(info.getValue()), meta: { className: "dt-center" } }),

		columnHelper.display({
			id: "acciones",
			header: "",
			cell: (info) => accionesPuesto(info.row.original),
			meta: { className: "dt-center" }
		}),
	]);
	return { columns, features };
}